const gbFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'GBP',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { gbFormats };
